import { FC } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useFlag } from "@unleash/proxy-client-react";
import { AppNavItemWrapper } from "../app-nav-components/AppNavItemWrapper";
import { useAppSelector } from "@/store/hooks";
import { navigationCollapsedSelector } from "@/store/common/selectors/navigation/navigationCollapsedSelector";

export const HomePageNavigation: FC = () => {
  const navigationCollapsed = useAppSelector(navigationCollapsedSelector);
  const enableHomePage = useFlag("EnableHomePage");

  if (!enableHomePage) {
    return null;
  }

  return (
    <AppNavItemWrapper
      to="/home"
      primary="Home"
      Icon={HomeOutlinedIcon}
      navCollapsed={navigationCollapsed}
    />
  );
};
